import { render, staticRenderFns } from "./UnifiedLayout.vue?vue&type=template&id=618ca40e&scoped=true&"
import script from "./UnifiedLayout.vue?vue&type=script&lang=ts&"
export * from "./UnifiedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./UnifiedLayout.vue?vue&type=style&index=0&id=618ca40e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ca40e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
